<!-- src/components/joakim/Sameign/VidmidunarTable.vue -->
<script setup lang="ts">
import { ref, watch, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useCurrency } from '@/composables/useCurrency'

const { t } = useI18n()
const { currency } = useCurrency()

type VidmidunItem = {
  vidmAr: number
  sjodsDeild: string
  vidmIdgjald: number
  vidmIdgjaldMedVerdbotum: number
}

const props = defineProps<{
  vidmidun: VidmidunItem[]
}>()

const vidmidunarData = ref<VidmidunItem[]>([])

// sync prop → local ref
watch(
  () => props.vidmidun,
  newVal => {
    vidmidunarData.value = newVal ?? []
  },
  { immediate: true }
)

const headers = computed(() => [
  { title: t('VidmidunTable__vidmAr'), key: 'vidmAr', sortable: false },
  { title: t('VidmidunTable_sjodsDeild'), key: 'sjodsDeild', sortable: false },
  { title: t('VidmidunTable_vidmIdgjald'), key: 'vidmIdgjald', align: 'end' as const, sortable: false },
  { title: t('VidmidunTable_vidmIdgjaldMedVerdbotum'), key: 'vidmIdgjaldMedVerdbotum', align: 'end' as const, sortable: false }
])
</script>

<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="vidmidunarData"
      :loading="vidmidunarData.length === 0"
      loading-text="Sæki gögn..."
      no-data-text="Engin gögn fundust"
      :items-per-page-text="t('perpage')"
      :mobile-breakpoint="0"
      hover
      class="vidmidun-data-table"
    >
      <template #item.vidmIdgjald="{ item }">
        {{ currency(item.vidmIdgjald) }} kr
      </template>

      <template #item.vidmIdgjaldMedVerdbotum="{ item }">
        {{ currency(item.vidmIdgjaldMedVerdbotum) }} kr
      </template>
    </v-data-table>
  </div>
</template>

<style scoped lang="scss">
.vidmidun-data-table {
  padding: 0 !important;

  :deep(.v-table) {
    .v-table__wrapper table tbody tr {
      border-bottom: 1px solid #eee;
    }

    .v-table__wrapper table thead tr th {
      border-bottom: none;
      font-weight: 600;
      font-size: 14px;
    }

    .v-table__wrapper table tbody tr td {
      padding: 8px;
    }
  }
}
</style>
